<template>
  <v-row dense>
    <v-col cols="12" md="8">
      <v-card class="info-card pa-6" outlined>
        <v-skeleton-loader
          v-if="loading"
          type="card-heading, article"
        ></v-skeleton-loader>
        <div v-else class="d-flex justify-space-between align-center">
          <div>
            <p class="mb-1 text-uppercase caption grey--text">
              Visão estratégica
            </p>
            <h2 class="font-weight-medium mb-2">Total de Cadastros</h2>
            <div class="display-2 font-weight-bold">
              {{ formatNumber(totalCadastro) }}
            </div>
            <p class="caption grey--text mt-2">
              Dados consolidados com base nas seleções atuais.
            </p>
          </div>
          <v-avatar color="primary" size="72">
            <v-icon color="white" large>mdi-account-group</v-icon>
          </v-avatar>
        </div>
      </v-card>
    </v-col>
    <v-col cols="12" md="4">
      <v-card class="meta-card pa-6" outlined>
        <v-skeleton-loader
          v-if="loading"
          type="card-heading, list-item-two-line"
        ></v-skeleton-loader>
        <template v-else>
          <div class="d-flex justify-space-between align-center">
            <div>
              <p class="mb-1 text-uppercase caption grey--text">
                Meta Departamental
              </p>
              <h3 class="font-weight-medium mb-2">
                Progresso {{ metaProgress | formatPercent }}
              </h3>
            </div>
            <v-icon color="success" large>mdi-target</v-icon>
          </div>
          <v-progress-linear
            class="my-4"
            rounded
            height="10"
            color="success"
            :value="metaProgress"
          ></v-progress-linear>
          <div class="d-flex justify-space-between">
            <div>
              <p class="caption grey--text mb-0">Meta</p>
              <p class="subtitle-1 font-weight-medium">
                {{ formatNumber(totalMeta) }}
              </p>
            </div>
            <div class="text-right">
              <p class="caption grey--text mb-0">Restante</p>
              <p class="subtitle-1 font-weight-medium">
                {{ formatNumber(metaRemaining) }}
              </p>
            </div>
          </div>
        </template>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { formatNumber } from "./utils/formatters";

export default {
  name: "KpiCards",
  props: {
    totalCadastro: {
      type: Number,
      default: 0,
    },
    totalMeta: {
      type: Number,
      default: 0,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    metaProgress() {
      if (!this.totalMeta) return 0;
      const percent = (this.totalCadastro / this.totalMeta) * 100;
      return Math.min(Math.max(Number(percent.toFixed(2)), 0), 200);
    },
    metaRemaining() {
      if (!this.totalMeta) return 0;
      return Math.max(this.totalMeta - this.totalCadastro, 0);
    },
  },
  filters: {
    formatPercent(value) {
      const numeric = Number(value) || 0;
      return `${numeric.toFixed(1)}%`;
    },
  },
  methods: {
    formatNumber,
  },
};
</script>

<style scoped>
.info-card,
.meta-card {
  border-radius: 16px;
  min-height: 140px;
}
</style>
